const Marquee = ({ items, dark = false, testId = "editorial-marquee" }) => (
  <div
    data-testid={testId}
    className={`overflow-hidden border-y ${
      dark ? "border-darkborder bg-obsidian text-[#F5F5F0]" : "border-sand bg-surface text-charcoal"
    }`}
  >
    <div className="marquee-track flex w-max py-5">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-wide sm:text-3xl">
                {item}
              </span>
              <span className={`h-px w-8 ${dark ? "bg-darkborder" : "bg-sand"}`} aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
